module.exports = __webpack_public_path__ + "static/media/home.a84704e5.svg";